<cpi-modal [title]="labels.lbl_geral_opcoes_de_coluna" [showFooter]="true" (onModalClose)="resetHeaderForm()" #customizeHeaderModal>
	<ng-container body>
		<cpi-generic-form-gen [setGenericForm]="headersForm ? [headersForm] : []" [labels]="labels"> </cpi-generic-form-gen>
	</ng-container>
	<ng-container footer>
		<div class="button-container">
			@if (defaultHeaders?.length > 0) {
				<button (click)="resetHeaders()">{{ labels.lbl_geral_redefinir }}</button>
			}
			<button (click)="fSaveHeaders()">
				{{ labels.lbl_geral_salvar }}
			</button>
		</div>
	</ng-container>
</cpi-modal>
